<div>
  {{ data | number: '.3' }}
</div>
